<template>
  <div class="main-text">
    <div class="home">
      <div class="left">
        <h4 class="headline">Blue Ridge</h4>
        <h5>Microfinance Bank Ltd</h5>
        <p class="interest">
          is a CBN Approved company that economically empower micro-entrepreneurs and unbanked people by providing no collateral loans using our apps OKash and EaseMoni. Loans range from ₦4,000 to ₦1,000,000 with a repayment period of 14 days to 12 months. Customers can also take out multiple loans with a total maximum value of ₦1,000,000.
        </p>
        <img class="cbn" src="@/assets/img/cbn.png" alt="">
      </div>
      <!-- <a href="https://www.brmfbank.com/apk/BlueRidgeNigeria_1.1.8.3046_official_official_final.apk" class="download-btn"  target="_self">
                <img src="@/assets/img/download.png" alt="" class="download-icon">
                Download From Website
            </a> -->
      <div class="right">
        <div class="ok common">
          <img class="logo" src="@/assets/img/OK.png" alt="">
          <span>OKash</span>
          <img class="google_play" src="@/assets/img/google_play.png" alt="" @click="toOK">
        </div>
        <div class="em common">
          <img class="logo" src="@/assets/img/EM.png" alt="">
          <span>EaseMoni</span>
          <img class="google_play" src="@/assets/img/google_play.png" alt="" @click="toEM">
        </div>
      </div>
    </div>
    <ul class="nav-list">
      <li>
        <img class="logo" src="@/assets/img/safety.png" alt="">
        <span>Full Safety Guaranteed</span>
      </li>
      <li>
        <img class="logo" src="@/assets/img/bank.png" alt="">
        <span>Professional digital bank</span>
      </li>
      <li>
        <img class="logo" src="@/assets/img/products.png" alt="">
        <span>Flexible loan products</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  methods: {
    toOK() {
      window.location.href = 'https://okash.onelink.me/rWwB/gi1tphhu'
    },
    toEM() {
      window.location.href = 'https://myem.onelink.me/qpgB/aan3leel'
    }
  },
}
</script>
<style lang="scss" scoped>
@import '@/styles/public.scss';
.home {
  width: 1440px;
  background-image: url('~@/assets/img/banner.png');
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  padding: 155px 119px 67px 121px;
  @include flex-base;
}
.left {
  flex: 1;
  h4 {
    color: #fff;
    font-size: 50px;
    line-height: 64px;
  }
  h5 {
    color: #fff;
    font-size: 40px;
    line-height: 64px;
  }
  .interest {
    color: #fff;
    font-size: 20px;
    line-height: 32px;
    margin: 24px 0 40px;
  }
  .cbn {
    // width: 200px;
    height: 28px;
  }
}
.right {
  width: 600px;
  padding: 91px 58px 109px;
  margin-left: 60px;
  border-radius: 40px;
  background: rgba(255, 255, 255, 0.3);
  @include flex-base;
  .common {
    @include flex-center;
    flex-direction: column;
    .logo {
      width: 120px;
      height: 120px;
    }
    span {
      margin: 21.16px 0 22.48px;
      color: #210F60;
      font-size: 18px;
      // font-weight: 600;
    }
    .google_play {
      width: 192px;
      height: 57px;
    }
  }
}
.nav-list {
  @include flex-base;
  padding: 72px 130px;
  li {
    flex: 1;
    text-align: center;
    &:nth-child(2) {
      margin: 0 180px 0 170px;
    }
    img {
      width: 60px;
      height: 60px;
    }
    span {
      display: block;
      margin-top: 36px;
      font-size: 24px;
      line-height: 32px;
    }
  }
}
</style>
